export default __webpack_public_path__ + "static/media/carousel-visaease-logo.08e4fd86.jpg";